<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState,mapGetters,mapActions } from "vuex"
import Loader from "@/components/widgets/preloader";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select"

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Consumable",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "addedOn",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      nameError: "",
      unitError: "",

      // Value from user input for adding category
      data: {
        name: "",
        unit: "",
        quantity: ""
      },
      // edit unit
      editdata: {
        name: "",
        unit: "",
        quantity: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("products", ["Units"]),
    ...mapGetters("consumables", ["SaveStatus", "Consumables"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Consumables ? this.Consumables.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Consumables ? this.Consumables.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
        this.resetError();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      AddItem: "consumables/addConsumables",
      EditItem: "consumables/editConsumables",
      DeleteConsumables: "consumables/deleteConsumables",
      FetchUnits: "products/fetchUnits",
      FetchConsumables: "consumables/fetchConsumables",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkData(){
      if (this.data.name !="" && this.data.unit!=''){
        let Cons = this.Consumables.filter((item)=>{
          return  item.phone ==  parseInt(this.data.unit) ;
        })
        let ConsCount =Cons.length;
        if (ConsCount>0){
          this.contactError="This consumable in units "+this.data.unit+"  already Exists";
        }
      }

    },
    checkEditData(){
      if (this.editdata.name !="" && this.editdata.unit!=''){
        let Cons = this.Consumables.filter((item)=>{
          return  item.phone ==  parseInt(this.editdata.unit) ;
        })
        let ConsCount =Cons.length;
        if (ConsCount>0){
          this.contactError="This consumable in units "+this.editdata.unit+"  already Exists";
        }
      }

    },

    addItem(modalId) {
        this.modal_id = modalId;

        if (this.data.name === "") {
            this.nameError = "Item name field is required";
            return;
        } else {
            this.nameError = "";
        }
        if (this.data.unit === "") {
            this.unitError = "Item units field is required";
            return;
        } else {
            this.unitError = "";
        }
        this.checkData()
        if (this.unitError!=""){
          return this.unitError;
        } else {
          this.unitError = "";
        }
        this.AddItem(this.data);
    },
    editItem(modalId) {
      this.modal_id = modalId;

      if (this.editdata.name === "") {
        this.nameError = "Item name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.unit === "") {
        this.unitError = "Item units field is required";
        return;
      } else {
        this.unitError = "";
      }
      this.checkEditData()
      if (this.unitError!=""){
        return this.unitError;
      } else {
        this.unitError = "";
      }
      this.data.id = 
      this.EditItem(this.editdata);
    },

    resetAdd() {
      this.data.name = "";
      this.data.unit = "";
      this.data.quantity = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.name = "";
      this.editdata.unit = "";
      this.editdata.quantity = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.name;
      this.editdata.quantity = data.item.qty;
      this.editdata.unit = data.item.unit.name;
      this.editdata.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },
    deleteConsumables(modalId) {
      this.modal_id = modalId;
      this.DeleteConsumables(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchUnits();
    this.FetchConsumables();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-md-9">
                      <h4 class="card-title">All Consumable Items</h4>
                  </div>
                  <div v-if="MyUserPerm.add_consumable_items == 1" class="col-md-3" align="right">
                      <b-button v-b-modal.add-item-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
                  </div>
              </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Consumables?Consumables:[]"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button-group>
                  <b-button
                    v-if="MyUserPerm.edit_consumables == 1"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    v-if="MyUserPerm.delete_consumables == 1"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-item-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Loader v-if="!Consumables" />
        </div>
      </div>
    </div>
<!-- modal starts -->
    <b-modal id="add-item-modal" hide-footer @hidden="resetAdd">
    <template #modal-title> Add New Item </template>
    <div class="form-group mb-3">
        <label>Item Name</label>
        <div class="input-group">
        <input
            type="text"
            placeholder="Enter Item Name"
            class="form-control"        
            @input="resetError()"
            v-model="data.name"
        />
        </div>
        <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
        </div>
    </div>
    <div class="form-group mb-3">
        <label>Units</label>
        <div class="input-group">
          <input
              class="form-control"
              v-model="data.unit"
              list="units"
              @keyup = checkData()
              placeholder="Enter Product unit"
              autocomplete="off"
              />
              <datalist id="units">
              <option
                  v-for="(cat, c) in Units"
                  :data-value="cat.name"
                  :key="c"
              >
                  {{ cat.symbol }}
              </option>
              </datalist>
          </div>
          <div class="text-danger" v-if="unitError">
          <em>{{ unitError }}</em>
          </div>
    </div>
    <div class="form-group mb-3">
        <label>Quantity</label>
        <div class="input-group">
        <input
            type="number"
            placeholder="Enter Quantity"
            class="form-control"
            @input="resetError()"
            v-model="data.quantity"
        />
        </div>
    </div>
    <div class="modal-footer">
        <button
        type="button"
        class="btn btn-danger"
        data-dismiss="modal"
        @click="closeModal('add-item-modal')"
        >
        <i class="fa fa-times"></i> Close
        </button>
        <button
        type="button"
        class="btn btn-primary"
        @click="addItem('add-item-modal')"
        > <i class="fa fa-check"></i>
        Submit
        <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
        ></b-spinner>
        </button>
    </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
            <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
              <template #modal-title> Edit Consumable {{ editdata.name }}</template>
              <div class="form-group mb-3">
                <label>Item Name</label>
                <div class="input-group">
                <input
                    type="text"
                    placeholder="Enter Item Name"
                    class="form-control"         
                    @input="resetError()"
                    v-model="editdata.name"
                />
                </div>
                <div class="text-danger" v-if="nameError">
                    <em>{{ nameError }}</em>
                </div>
            </div>
            <div class="form-group mb-3">
                <label>Units</label>
                <div class="input-group">
                <model-list-select
                    :list="Units ? Units : []"
                    v-model="editdata.unit"
                    option-value="id"
                    option-text="name"
                    @input="resetError()"
                    placeholder="Select Units"
                    @keyup="checkEditData()"
                >
                </model-list-select>
                </div>
                <div class="text-danger" v-if="unitError">
                    <em>{{ unitError }}</em>
                </div>
            </div>
            <div class="form-group mb-3">
                <label>Quantity</label>
                <div class="input-group">
                <input
                    type="number"
                    placeholder="Enter Quantity"
                    class="form-control"
                    @input="resetError()"
                    v-model="editdata.quantity"
                />
                </div>
            </div>
            <div class="modal-footer">
                <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('edit-item-modal')"
                >
                <i class="fa fa-times"></i> Close
                </button>
                <button
                type="button"
                class="btn btn-primary"
                @click="editItem('edit-item-modal')"
                > <i class="fa fa-check"></i>
                Submit
                <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                ></b-spinner>
                </button>
            </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete category starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-item-modal"
              hide-footer
              @hidden="resetDelete"
            >
              <template #modal-title> Delete Consumable {{ deletedata.name }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Consumable Item? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-item-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteConsumables('delete-item-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
